export default async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return blob;
};
